import { TimeSlot } from "./doctor.definition";
import { ProvidedServiceType } from "./doctor.definition";
import { PaginationSettingsResponse } from "./search.definition";
import { Location, UserInfo } from "./user.definition";

export type AStep = (typeof StepsEnum)[keyof typeof StepsEnum];

export const StepsEnum = {
  DATE_TIME: "DATE_TIME",
  VALIDATION: "VALIDATION",
  PAYMENT: "PAYMENT",
  CONFIRMATION: "CONFIRMATION",
};

export type AppointmentStatus =
  (typeof AppointmentStatusEnum)[keyof typeof AppointmentStatusEnum];

export const AppointmentStatusEnum = {
  PENDING: "PENDING",
  CANCELED: "CANCELED",
  IN_PROGRESS: "IN_PROGRESS",
  CONFIRMED: "CONFIRMED",
  COMPLETE: "COMPLETE",
};

export type AppointmentInfo = Omit<Appointment, "id">;
export type Appointment = {
  id?: string;
  patientId: string;
  doctor?: UserInfo;
  patient?: UserInfo;
  doctorId: string;
  reason: string;
  timeSlotId: number;
  appointmentTime: string;
  healthcareFacilityId: number;
  status: AppointmentStatus;
  appointmentType: ProvidedServiceType;
  location?: Location;
};
export type AppointmentCreation = {
  appointment: AppointmentInfo | null;
  timeSlot: TimeSlot | null;
  step: number | null;
  createdAppointment: AppointmentInfo | null;
};

export type AppointmentSearchResponse = {
  data: Appointment[];
  paginationSettings: PaginationSettingsResponse;
};
